// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "span.label[data-v-89e73db4]{font-weight:700}", "",{"version":3,"sources":["webpack://./resources/js/Pages/Orders/Show/ContactDetails.vue"],"names":[],"mappings":"AACI,4BACI,eAAA","sourcesContent":["\n    span.label {\n        font-weight: bold;\n    }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
